export const calendarTranslations = (
    displayBlockDatesFeature: boolean,
    renderAvailabilityCalendar: boolean
) => ({
    bookingTitle: {
        id: displayBlockDatesFeature
            ? 'service.booking.ad.disable.dates.title'
            : 'service.booking.ad.title',
        defaultMessage: displayBlockDatesFeature
            ? 'Manage your calendar'
            : renderAvailabilityCalendar
            ? 'Request for reservation'
            : 'Check availability'
    },
    bookingDescription: {
        id: displayBlockDatesFeature
            ? 'service.booking.ad.disable.dates.description'
            : 'service.booking.ad.description',
        defaultMessage: displayBlockDatesFeature
            ? 'You are the owner of this ad. You can mark unavailable days here and they will be not bookable by users.'
            : renderAvailabilityCalendar
            ? 'Select the date range that you want to request the rental. It is free and non-binding.'
            : 'It costs nothing and is without obligation.'
    }
});

export const blockDatesLegend = [
    {
        id: 'service.booking.ad.enable.dates',
        defaultMessage: 'Available days',
        isDotInformation: true,
        isAvailableDates: true
    },
    {
        id: 'service.booking.ad.disable.dates.by.customer',
        defaultMessage: 'Booked dates',
        isDotInformation: false,
        isAvailableDates: false
    },
    {
        id: 'service.booking.ad.disable.dates.by.you',
        defaultMessage: 'Blocked dates',
        isDotInformation: true,
        isAvailableDates: false
    }
];
